import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'btn-cell-rendererSupportiveDocument',
  template: `
    <button
      mat-mini-fab
      color="primary"
      title="Download Document"
      (click)="onClick($event)">
      <mat-icon>download</mat-icon>
    </button>
    <button *ngIf='params.data.editMode'
      mat-mini-fab
      color="warn"
      title="Remove Document"
      (click)="onClick($event)">
      <mat-icon>delete</mat-icon>
    </button>
  `,
  styles: [
    `
      button {
        height: 35px;
        width: 35px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin: 0 3px;
      }
      .mat-icon {
        transform: scale(0.7);
      }
    `,
  ],
})
// tslint:disable-next-line:component-class-suffix
export class BtnCellRendererSupprotiveDocument implements ICellRendererAngularComp {
  public params: any;


  refresh(params: any): boolean {
    //throw new Error('Method not implemented.');
    this.params = params;
    return true;
  }
  public agInit(params: any): void {
    this.params = params;
  }
  onClick($event: any): any {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
      };
      this.params.onClick(params);
    }
  }
}
